module.exports = __webpack_public_path__ + "media/images/area/area_tohokuM400-cb784216e2371c5b21ba643e6ac8f913.jpg";